<template>
    <BuyBar/>
</template>

<script>
// @ is an alias to /src
import BuyBar from '../components/BuyBar.vue'

export default {
  name: 'buy-bar',
  components: {
    BuyBar
  }
}
</script>
